import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';


import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import '../scss/style.scss'
import '../scss/core/_dropdown-menu-right.scss'
import './styles/system-ui.css'

import Full from './containers/Full/'

import AuthenticatedRoute from './AuthenticatedRoute/'

import Login from './views/Pages/Login/'
import Locked from './views/Pages/Locked/'
import Register from './views/Pages/Register/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

import Escribania from './views/Escribania/Escribania.js'
import EscribaniaExito from './views/Escribania/Success.js'


import { DragDropContextProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

ReactDOM.render((
  <DragDropContextProvider backend={HTML5Backend}>
    <HashRouter>
      <Switch>
        <Route exact path="/login" name="Login Page" component={Login} />
        <Route exact path="/register" name="Register Page" component={Register} />
        <Route exact path="/404" name="Page 404" component={Page404} />
        <Route exact path="/500" name="Page 500" component={Page500} />
        <Route exact path="/escribania" name="Escribania" component={Escribania} />
        <Route exact path="/escribaniaexito" name="EscribaniaExito" component={EscribaniaExito} />
        <AuthenticatedRoute exact path="/locked" name="Locked Page" component={Locked} />
        <AuthenticatedRoute path="/" component={Full} />
      </Switch>
    </HashRouter>
  </DragDropContextProvider>

), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js